import { Typography } from 'antd'

import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'

export const SearchResultCount = ({ search }: { search: string }) => {
  const { total } = useRemoteTableStore(state => state.pagination)

  return (
    <Typography.Title level={5}>
      为您找到与 “{search}” 相关的结果共 {total} 条
    </Typography.Title>
  )
}
